import { ErrorApi } from 'api/interfaces';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getAssembleiasAssessorEndpoint } from 'library/Apis';
import { Dispatch } from 'redux';
import ApiService from 'services/ApiService';
import PerfilAssociado from 'store/modules/auth/PerfilAssociado';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import {
  getParsedJWTAssessorAccessToken,
  getParsedJWTAssociadoAccessToken,
  JWTAssessorJson,
  JWTAssociadoJson,
} from 'helpers/utils/JWTUtils';
import { pautaUtilsClear } from 'helpers/utils/PautaUtils';
import { toRequest } from 'helpers/utils/RequestUtils';
import { IAuthUserPerfil } from './auth/IAuthUserPerfil';
import {
  AUTH_ACTIONS_LOADING,
  AUTH_ACTIONS_LOGIN,
  AUTH_ACTIONS_LOGOUT,
  AUTH_ACTIONS_REGISTER_REDIRECT_PATH,
  IAuthActionsLogout,
  IAuthActionsRegisterRedirectPath,
} from './AuthActionTypes';
import { IAuthByToken, IAuthUserReducer } from './AuthReducer';

export function authActionsRegisterRedirectPath(
  path: string | undefined
): IAuthActionsRegisterRedirectPath {
  return {
    type: AUTH_ACTIONS_REGISTER_REDIRECT_PATH,
    payload: path,
  };
}

export const authActionsLogin = (
  accessToken: string,
  callbackSuccess?: (user: IAuthUserReducer) => void,
  callbackError?: Function
) => {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: AUTH_ACTIONS_LOADING,
      payload: true,
    });
    const parsedToken: JWTAssociadoJson | null =
      getParsedJWTAssociadoAccessToken(accessToken);
    const perfil: IAuthUserPerfil = PerfilAssociado;
    if (perfil && parsedToken) {
      try {
        const payload: IAuthUserReducer = {
          nome: parsedToken.name || '',
          cpfCnpj: parsedToken.preferred_username,
          perfil,
          associadoAccessToken: accessToken,
        };
        dispatch({
          type: AUTH_ACTIONS_LOGIN,
          payload,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(payload);
        }
      } catch (error) {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    } else {
      if (typeof callbackError === 'function') {
        callbackError();
      }
    }
  };
};

export function authActionsLogout(): IAuthActionsLogout {
  pautaUtilsClear();
  return {
    type: AUTH_ACTIONS_LOGOUT,
    payload: undefined,
  };
}

export const authActionsLoginByToken = (
  accessToken: string,
  callbackSuccess?: (user: IAuthUserReducer) => void,
  callbackError?: (error: AxiosError | null) => void
) => {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: AUTH_ACTIONS_LOADING,
      payload: true,
    });
    const parsedToken: JWTAssessorJson | null =
      getParsedJWTAssessorAccessToken(accessToken);
    const perfil: IAuthUserPerfil | null = parsedToken
      ? getProfileByJWTRoles(parsedToken.roles)
      : null;
    new Promise(
      (
        resolve: (data: IAuthUserReducer) => void,
        reject: (error: AxiosError | null) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssessorEndpoint()}token/`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            } as AxiosRequestConfig,
          ],
          'usuarioToken'
        )
          .then((resp: AxiosResponse<IAuthByToken>) => {
            const response = resp.data;
            const data: IAuthUserReducer = {
              nome: response.nome,
              cpfCnpj: response.ldap,
              ldapAccessToken: accessToken,
              ldap: response.ldap,
              coops: response.coops,
              perfil: perfil!,
              tokenWs: accessToken,
            };
            dispatch({
              type: AUTH_ACTIONS_LOGIN,
              payload: data,
            });
            resolve(data);
          })
          .catch((error: AxiosError<ErrorApi>) => {
            reject(error);
          });
      }
    ).then(
      (data: any) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
